const PageLoader = () => {
  return (
    <main className="w-full h-full flex-1 flex justify-center items-center min-h-[calc(100vh-8rem)]">
      <div className="loader flex items-center justify-center" />
    </main>
  );
};

export default PageLoader;
